import request from '@/utils/request'
import env from '@/env'
export function getBannerList (params: any) {
    return request({
        url: env.testUrlWeb + '/banner/bannerQuery',
        method: 'POST',
        data: params,
    })
}